import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DistributeLoadModalComponent } from '@app/performance/performance-test/distribute-load-modal/distribute-load-modal.component';
import { PerformanceService } from '@app/performance/performance.service';
import { TestCaseService } from '@app/testcase/testcase.service';
import { UserService } from '@app/user/user.service';
import { AuthenticationService } from '@app/_services';
import { NgbDateCustomParserFormatter } from '@app/_shared/date-formatter.service';
import { DistributeLoadHelpModalComponent } from '@app/_shared/distribute-load-help-modal/distribute-load-help-modal.component';
import { LoadSizeHelpModalComponent } from '@app/_shared/load-size-help-modal/load-size-help-modal.component';
import { NgbCalendar, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { constants, errorMessages } from '@assets/data/constants';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-meta-data-form',
  templateUrl: './meta-data-form.component.html',
  styleUrls: ['./meta-data-form.component.less'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
  ]
})
export class MetaDataFormComponent implements OnInit, OnChanges {

  @Input() perfLab: any;
  @Input() loadTestType: any;
  @Input() goveranceForm = {};

  @Output() goToPrevious: EventEmitter<any> = new EventEmitter();
  @Output() impactedSystemsData: EventEmitter<any> = new EventEmitter();
  @Output() enableAutoGovernance: EventEmitter<any> = new EventEmitter();
  @Output() submitLoadTestingData: EventEmitter<any> = new EventEmitter();

  userData: any;
  currentPSTTime: any;
  loadTypes = [];
  blockedSlots = [];
  userITDept = false;
  metaDataForm: FormGroup;
  executionLocations = [];

  errorMsg = '';
  formSubmitted = false;

  // Datepicker
  startMinDate: any;
  endMinDate: any;
  users: any;
  impactedSystems: any[];

  constructor(private toastr: ToastrService, private performanceService: PerformanceService, public ngbCalendar: NgbCalendar, private authService: AuthenticationService, private userService: UserService, private testCaseService: TestCaseService,
    private router: Router, private modalService: NgbModal) { }

  ngOnInit() {
    const todayDate = moment();
    this.currentPSTTime = todayDate.tz('America/Los_Angeles').format('DD-MM-YYYY hh:mm:ss A')
    const dateObject = {
      year : todayDate.year(),
      month : todayDate.month() + 1,
      day : todayDate.date()
    }

    this.startMinDate = dateObject;
    this.endMinDate = dateObject;
    this.loadTypes = JSON.parse(localStorage.getItem('about')).loadTypes;
    this.executionLocations = JSON.parse(localStorage.getItem('about')).executionLocations;
    this.authService.currentUser.subscribe(data => {
      this.userData = data;
      this.userITDept = (this.userData.userMetadata.department === constants.informationTechnology) ? true : false;
    });

    this.initiateForm();
  }

  ngOnChanges() {
    if (this.metaDataForm !== undefined && this.perfLab !== {}) {
      this.metaDataForm.controls.perfLab.setValue(this.perfLab);
    }
    this.initiateForm();
    this.changeFlowType()
  }

  initiateForm() {
    this.metaDataForm = new FormGroup({
      loadTestType: new FormControl(),
      perfLab: new FormControl(),
      durationType: new FormControl('nextAvailable'),
      startTime: new FormControl(),
      autoGoveranceStartDate: new FormControl(),
      autoGoveranceEndDate: new FormControl()
    });
    this.metaDataForm.controls.perfLab.setValue(this.perfLab);

    this.perfLabValue.parallelFlow = this.perfLabValue.loadTestConfig.parallelFlow;
    this.changeFlowType();
  }

  openDistributedModal() {
    const distributedModalRef = this.modalService.open(DistributeLoadModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: true,
      windowClass: 'confirm-modal',
      centered: true,
      size: 'lg'
    });
    distributedModalRef.componentInstance.testCaseEndPointLoadTestConfigs = this.perfLabValue.loadTestConfig.loadTestEndPointConfigs;
    distributedModalRef.componentInstance.updatedDistributedLoad.subscribe((data: any) => {
      this.perfLabValue.loadTestConfig.loadTestEndPointConfigs = data;
    });
  }

  openDistributedHelpModal() {
    const modalRef = this.modalService.open(DistributeLoadHelpModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: true,
      windowClass: 'confirm-modal',
      size: 'lg'
    });
  }

  openHelpText() {
    const modalRef = this.modalService.open(LoadSizeHelpModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: true,
      windowClass: 'confirm-modal',
      size: 'lg'
    });
  }

  viewSlots() {
    let startDate: string;
    let endDate: string;
    if (this.autoGoveranceStartDateValue && this.autoGoveranceEndDateValue) {
      const startTime = (this.startTimeValue && this.startTimeValue !== undefined) ? this.formatTimeToString(this.startTimeValue) : constants.defaultTimestamp;
      startDate = this.formatDateTimeToString(this.autoGoveranceStartDateValue, startTime);
      endDate = this.formatDateTimeToString(this.autoGoveranceEndDateValue, constants.defaultLastTimestamp);
    } else {
      this.toastr.error(errorMessages.viewSlotsError);
      return false;
    }
    const params = {
      startTime: startDate,
      endTime: endDate,
      loadTestType: this.perfLabValue.testCase.loadTestType
    };
    this.performanceService.viewSlots(params).subscribe(data => {
      if (data.code === 200) {
        this.blockedSlots = data.response;
      } else {
        this.blockedSlots = [];
      }
    });
  }

  setToday(dateControl: string | number) {
    this.metaDataForm.controls[dateControl].setValue(this.ngbCalendar.getToday());
  }

  resetDate(dateControl: string | number) {
    this.metaDataForm.controls[dateControl].reset();
  }

  setEndDate(startDate: any) {
    this.metaDataForm.controls.autoGoveranceStartDate.setValue(startDate);
    this.endMinDate = startDate;
    this.metaDataForm.controls.autoGoveranceEndDate.reset();
  }

  selectEndDate(endDate: any) {
    this.metaDataForm.controls.autoGoveranceEndDate.setValue(endDate);
  }

  formatDateTimeToString(dateTime, timeStamp) {
    const month = dateTime.month > 9 ? dateTime.month : '0' + dateTime.month;
    return (dateTime.year + '-' + month + '-' + dateTime.day + ' ').concat(timeStamp);
  }

  formatTimeToString(time){
    const hour = time.hour > 9 ? time.hour : '0' + time.hour;
    const minute = time.minute > 9 ? time.minute : '0' + time.minute;
    const second = time.second > 9 ? time.second : '0' + time.second;
    return (hour + ':' + minute + ':' + second + '');
  }

  loadTypeSelect(loadType: any) {
    this.perfLabValue.loadTestConfig.load_type = loadType;
    /* To Make the iteration false if custom is not selected */
    if (loadType !== 'CUSTOM') {
      this.perfLabValue.loadTestConfig.iteration = false;
      if (this.perfLabValue.iteration !== undefined) {
        this.perfLabValue.iteration = false;
      }
    }
  }

  locationSelect(executionLoc: any) {
    this.perfLabValue.loadTestConfig.location = executionLoc;
  }

  goBack() {
    this.goToPrevious.emit();
  }

  disabledScheduleBtn() {
    if(this.perfLabValue.loadTestConfig === null || this.perfLabValue.loadTestConfig === undefined) {return;}
    if(!this.perfLabValue.loadTestConfig.location){
      return true;
    }
    // if (this.perfLabValue.loadTestConfig) {

    //   if (this.perfLabValue.loadTestConfig.iteration && this.perfLabValue.loadTestConfig.iterationCount <= 0) {
    //     return true;
    //   }
    // }

    /* Formal run */
    if (this.perfLabValue.parallelFlow && ((this.perfLabValue.loadTestConfig.noOfUsers < 15 && (!this.perfLabValue.loadTestConfig.iteration && this.perfLabValue.loadTestConfig.duration <= 10)))) {
      return true;
    }

    if (this.perfLabValue.parallelFlow && ((this.perfLabValue.loadTestConfig.noOfUsers < 15 && this.perfLabValue.loadTestConfig.iteration))) {
      return true;
    }

    /* DRY run */
    if (!this.perfLabValue.parallelFlow && (this.perfLabValue.loadTestConfig.noOfUsers > 14) && this.perfLabValue.testCase.loadTestType != 'WEB') {
      return true;
    }

    if (!this.perfLabValue.parallelFlow && (!this.perfLabValue.loadTestConfig.iteration && this.perfLabValue.loadTestConfig.duration > 10) && this.perfLabValue.testCase.loadTestType != 'WEB') {
      return true;
    }
    if (this.perfLabValue.parallelFlow && this.durationTypeValue === constants.durationTypeCustom && this.autoGoveranceStartDateValue && this.startTimeValue) {
      return false;
    }

    if (this.durationTypeValue === constants.durationTypeCustom && !(this.autoGoveranceEndDateValue && this.autoGoveranceStartDateValue && this.startTimeValue)) {
      return true;
    }

    return false;
  }

  showScheduleBtn() {
    if (((this.perfLabValue.loadTestConfig !== undefined )) || !this.userITDept) {
      return true;
    } else { return false; }
  }

  submitLoadTesting(loadTestData: any) {
    this.perfLabValue.storeResult = this.perfLabValue.loadTestConfig.storeResult;
    const perfLabData = Object.assign({}, loadTestData);
    this.submitLoadTestingData.emit({ perfLabValue: perfLabData });
  }

  changeFlowType(value?: any) {
    if (value !== undefined) {
      this.perfLabValue.parallelFlow = value;
    }

    const tempLoadType = JSON.parse(localStorage.getItem('about')).loadTypes;
    const list = [];
    const tempLocation = JSON.parse(localStorage.getItem('about')).executionLocations;

    /* Dry run */
    if (!this.perfLabValue.parallelFlow) {

      /* Location */
      this.executionLocations = tempLocation.filter((elem: any) => {
        return elem.location === 'OREGON';
      });
      // if dry run set the location as oregon by default
      this.perfLabValue.location = 'OREGON';
      this.perfLabValue.loadTestConfig.location = 'OREGON';

    } else { /* Formal run */
      this.executionLocations = JSON.parse(localStorage.getItem('about')).executionLocations;
    }
    this.loadTypes = list;
  }

  // GETTERs & SETTERs
  get perfLabValue() {
    return this.metaDataForm.controls.perfLab.value;
  }

  get durationTypeValue() {
    return this.metaDataForm.controls.durationType.value;
  }

  get autoGoveranceStartDateValue() {
    return this.metaDataForm.controls.autoGoveranceStartDate.value;
  }

  get autoGoveranceEndDateValue() {
    return this.metaDataForm.controls.autoGoveranceEndDate.value;
  }

  get startTimeValue() {
    return this.metaDataForm.controls.startTime.value;
  }
}
